import styled from '@emotion/styled';
import mediaQuery from '@/lib/styling/mediaQuery';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';

type SectionNameProps = {
  customColor?: string | null;
};

const SectionName = styled('h2')<SectionNameProps>(
  ({ theme, customColor }) => ({
    marginBottom: 18,
    color: customColor ?? theme.palette.primary.main,
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: 1,
    [mediaQuery(560)]: {
      fontSize: 22,
    },
  }),
  addHighContrastStyles(({ theme }) => ({
    color: theme.palette.text.primary,
  })),
);

export default SectionName;
